<template>
  <ion-page>
    <master-layout pageTitle="فروشگاه">
      <div id="pageTop"></div>
      <div v-if="siblings.length" class="service-top-menu">
        <div v-for="item in siblings" :class="'service-top-menu-item '+(currentCat && item._id===currentCat._id?'active':'')" :key="item._id">
          <router-link :to="item.children?parentUrl+item._id+'-':'/shopCategory/'+item._id">{{item.title}}</router-link>
        </div>
      </div>
      <div class="search-area">
        <div class="search-input-area">
          <div class="fancy-title-wrapper search-input-area" style="padding-bottom: 10px;">
            <div class="fancy-title light">
              <h3 class="center text-white">{{currentCat?currentCat.title:'فروشگاه کارن'}}</h3>
            </div>
          </div>
          <input ref="searchInputElement" type="text" @focusin="searchFocused=true" @focusout="setUnfocused" v-model="searchInput" class="form-control"
                 placeholder="نام محصول مورد نظر را بنویسید">

          <div class="search-results" v-if="searchFocused && searchInput.length>2">
            <div v-if="searchResults.length">
              <div class="result-item" @click="goToProductPage(item._id)" v-for="item in searchResults" :key="item._id">
                <div class="thumbnail">
                  <img :src="item.thumbnail" />
                </div>
                <div class="info">
                  <div class="title">{{item.title}}</div>
                  <div class="english_title">{{item.english_title}}</div>
                  <div class="cat_title">{{item.main_category?item.main_category.title:'--'}}</div>
                </div>
              </div>
            </div>
            <div v-else>نتیجه ای یافت نشد.</div>

          </div>
        </div>
      </div>
      <br/>
      <ion-grid id="categories-container">
        <ion-row>
          <ion-col size="6" v-for="item in categories" :key="item._id">
            <router-link :to="item.children?(currentUrl+item._id+'-'):'/shopCategory/'+item._id">
              <div class="brand-model-item">
                <div class="thumbnail">
                  <IonImg :src="(item.pic_url?item.pic_url:'https://carencar.com/desktop/img/logo.png')"/>
                </div>
                <div class="title">
                  <h4>{{ item.title }}</h4>
                </div>
              </div>
            </router-link>
          </ion-col>
        </ion-row>
      </ion-grid>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonGrid, IonRow, IonCol, IonPage, IonImg, useBackButton} from '@ionic/vue'
import {mapActions} from "vuex";

/**
 * ToDo:
 *  sibling categories on top
 *  top banner on first page
 *  cat title on top of page
 */
export default {
  name: "categories",
  data: function ()
  {
    return {
      searchInput:'',
      searchFocused:false,
      searchResults:[],
      siblings:[],
      parentUrl:'',
      currentCat:null,
      categories: [],
      fullCategories:null,
      currentUrl:'',
      navigatedItems:[],
    }
  },
  mounted()
  {
    this.currentUrl = this.$route.fullPath;
    if (!this.currentUrl.endsWith('/') && !this.currentUrl.endsWith('-'))
      this.currentUrl+='/';

    this.setNavigatedItems(this.$route.fullPath);

    this.getCategoriesStructure().then((categories)=>{
      this.fullCategories = categories;
      this.setCategories();
    });


    useBackButton(10, async (processNextHandler)=>
    {
      if (this.searchFocused)
      {
        this.$refs.searchInputElement.blur()
        this.searchFocused = false;
      }
      else
        processNextHandler();
    });


  },
  methods: {
    goToProductPage(productId)
    {
      this.$router.push({path:'/ShopProduct/'+productId})
    },
    setUnfocused()
    {
      setTimeout(()=>{
        this.searchFocused=false;
      },50)
    },
    initItems(url)
    {
      const elmnt = document.getElementById("pageTop");
      elmnt.scrollIntoView();

      this.currentUrl = url;
      if (!this.currentUrl.endsWith('/') && !this.currentUrl.endsWith('-'))
        this.currentUrl+='/';

      this.setNavigatedItems(url);

      this.setCategories();
    },
    setNavigatedItems(url){
      const params = url.split('/');
      let categoryId = params.length===3?params[2]:null
      if (categoryId)
      {
        this.navigatedItems = categoryId.slice(0,(categoryId.length-1)).split('-');
      }
      else
        this.navigatedItems = [];
    },
    ...mapActions("shop", {
      getCategoriesStructure: 'getCategoriesStructure',
      searchProduct:"searchProduct"
    }),
    setCategories()
    {
      if (this.navigatedItems && this.navigatedItems.length)
      {
        let filteredCategories = JSON.parse(JSON.stringify(this.fullCategories));
        for (let j=0;j<this.navigatedItems.length;j++)
        {
          const n = this.navigatedItems[j];

          if (j===(this.navigatedItems.length-1))
          {
            this.siblings = JSON.parse(JSON.stringify(filteredCategories));
            const navItems = JSON.parse(JSON.stringify(this.navigatedItems));
            navItems.splice(-1,1)
            if (navItems.length)
            {
              this.parentUrl = '/Shop/'+navItems.join('-')+'-';
            }
            else
            {
              this.parentUrl='/Shop/';
            }
          }

          let found = false;
          for (let i=0;i<filteredCategories.length;i++)
          {
            const p = filteredCategories[i];
            if (p._id===n)
            {
              this.currentCat = JSON.parse(JSON.stringify(p))
              found = true;
              filteredCategories = JSON.parse(JSON.stringify(p.children));
            }
          }
          if (!found)
          {
            console.log('category not found');
            break;
          }
        }
        this.categories = filteredCategories;
      }
      else
      {
        this.siblings = [];
        this.categories = JSON.parse(JSON.stringify(this.fullCategories));
      }
    }
  },
  components: {
    IonGrid, IonRow, IonCol, IonPage,IonImg
  },
  props:{
    default:null
  },
  watch: {
    async searchInput()
    {
      if (this.searchInput.length && this.searchInput.length>2)
      {
        const searchData = {keyword:this.searchInput,max_results:12};
        if (this.currentCat)
        {
          searchData.categories = this.currentCat._id;
        }
        const result = await this.searchProduct(searchData);
        if (result && result.products)
          this.searchResults = result.products;
      }
    },
    '$route.path': {
      handler(newUrl)
      {
        if (newUrl.toString()==='/Shop' || newUrl.toString().startsWith('/Shop/'))
        {
          this.searchResults = [];
          this.searchInput = '';
          this.initItems(newUrl)
        }
      }
    }
  }
}
</script>

<style scoped>

.search-input-area {
  padding: 10px 15px 40px;
  background: #00295e;
  position: relative;
}

.result-area .table-responsive {
  max-height: 350px;
  overflow-y: auto;
}
.thumbnail{
  text-align: center;
}
.thumbnail img, .thumbnail ion-img{
  width: 125px;
  height: 125px;
  border-radius: 5px;
}

.title h4 {
  font-size: 16px;
  height: 45px;
}
.search-results {
  position: absolute;
  z-index: 5;
  background: #fff;
  width: calc(100% - 15px);
  border-radius: 8px;
  margin-top: 6px;
  box-shadow: 0 0 5px 0;
  margin-right: -8px;
  padding: 5px;
  max-height: 260px;
  overflow-y: auto;
}
.result-item {
  display: flex;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 4px;
  padding-bottom: 5px;
  position: relative;
}
.result-item:last-child{
  border-bottom: none;
}
.result-item .thumbnail {
  width: 60px;
}
.result-item .thumbnail img {
  max-width: 100%;
  max-height: 60px;
}
.result-item .info {
  width: calc(100% - 60px);
}
.result-item .info .title {
  font-size: 14px;
}
.result-item .info .english_title {
  font-size: 12px;
  color: #646464;
}
.result-item .info .cat_title {
  font-size: 12px;
  color: #393939;
  position: absolute;
  left: 5px;
  bottom: 12px;
}
</style>